import Vue from 'vue'
import container from './container'
import topbar from './topbar'
import footerbar from './footerbar'
import banner from './banner'
import img from './img'
import blockHead from './block-head'
import imgCard from './img-card'
import subBanner from './sub-banner'
import lrLayout from './lr-layout'
import infoTitle from './info-title'
import infoColumn from './info-column'
import outCard from './out-card'
import fuIntroduction from './fu-introduction'
import infoNumCard from './info-num-card'
import mouse from './mouse'
import caseCard from './case-card'




Vue.component(container.name, container)
Vue.component(topbar.name, topbar)
Vue.component(footerbar.name, footerbar)
Vue.component(banner.name, banner)
Vue.component(img.name, img)
Vue.component(blockHead.name, blockHead)
Vue.component(imgCard.name, imgCard)
Vue.component(subBanner.name, subBanner)
Vue.component(lrLayout.name, lrLayout)
Vue.component(infoTitle.name, infoTitle)
Vue.component(infoColumn.name, infoColumn)
Vue.component(outCard.name, outCard)
Vue.component(fuIntroduction.name, fuIntroduction)
Vue.component(infoNumCard.name, infoNumCard)
Vue.component(mouse.name, mouse)
Vue.component(caseCard.name, caseCard)

